import React, { useState } from "react";
import focus1 from "../../assets/img/about/17.png";
import focus2 from "../../assets/img/about/16.png";
import focus3 from "../../assets/img/about/34.png";
import focus4 from "../../assets/img/about/35.png";
import { TiTick } from "react-icons/ti";

const tabData = [
  {
    id: "mission",
    title: "Mission",
    image: focus2,
    heading: "Empowering Digital Transformation",
    description:
      "Our mission is to drive innovation through cutting-edge technology solutions, enabling businesses to thrive in the digital age. We are committed to delivering high-quality software that enhances efficiency, fosters growth, and creates lasting value for our clients across various industries.",
    points: [
      "Excellence in Development",
      "Set Industry Standards",
      "Drive Business Growth",
      "Create Lasting Value",
    ],
  },
  {
    id: "vision",
    title: "Vision",
    image: focus1,
    heading: "Shaping the Future of Technology",
    description:
      "Our vision is to be a global leader in technology innovation, driving transformative change across industries. We aspire to create a world where cutting-edge software empowers businesses and individuals to achieve their fullest potential. Through continuous learning and adaptation, we aim to set new benchmarks in quality, efficiency, and customer satisfaction.",
    points: [
      "Innovate for Tomorrow",
      "Exceed Industry Standards",
      "Empower Businesses",
      "Lead with Excellence",
    ],
  },
  {
    id: "career",
    title: "Careers",
    image: focus3,
    heading: "Join Our Innovative Team",
    description:
      "At our company, we believe in nurturing talent and fostering growth. We offer exciting opportunities for individuals who are passionate about technology and innovation. Join us to build a rewarding career in a dynamic and supportive environment, where your contributions drive real impact.",
    points: [
      "Grow with Us",
      "Innovate Together",
      "Build Your Career",
      "Make an Impact",
    ],
  },
  {
    id: "solution",
    title: "Solutions",
    image: focus4,
    heading: "Tailored Software Solutions",
    description:
      "We provide innovative and customized software solutions that cater to the unique needs of businesses across various industries. Our expertise ensures that our clients receive robust, scalable, and efficient solutions that drive success and foster growth.",
    points: [
      "Customized Solutions",
      "Industry Expertise",
      "Scalable Technology",
      "Driving Success",
    ],
  },
];

function OurFocus() {
  const [activeTab, setActiveTab] = useState("mission");

  return (
    <>
      <div className="career-section pd-top-120 ">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="section-title text-center">
                <h6 className="sub-title">ABOUT US</h6>
                <h2 className="title">
                  The Power Of <span>Software</span> The Simplicity Of Solutions
                </h2>
              </div>
            </div>
          </div>
          <div className="career-wrap-area">
            <nav>
              <div className="nav nav-tabs career-nav-tab" role="tablist">
                {tabData.map((tab) => (
                  <button
                    key={tab.id}
                    className={`nav-link ${
                      activeTab === tab.id ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    {tab.title}
                  </button>
                ))}
              </div>
            </nav>

            <div className="tab-content">
              {tabData
                .filter((tab) => tab.id === activeTab)
                .map((tab) => (
                  <div key={tab.id} className="career-wrap">
                    <div className="row">
                      <div className="col-lg-5">
                        <img src={tab.image} alt="img" />
                      </div>
                      <div className="col-lg-7">
                        <h3 className="mb-3">{tab.heading}</h3>
                        <p className="mb-3">{tab.description}</p>
                        <div className="row">
                          <div className="col-md-6">
                            <ul className="single-list-inner style-check style-heading style-check mb-3">
                              {tab.points
                                .slice(0, Math.ceil(tab.points.length / 2))
                                .map((point, index) => (
                                  <li key={index}>
                                    <TiTick /> {point}
                                  </li>
                                ))}
                            </ul>
                          </div>
                          <div className="col-md-6">
                            <ul className="single-list-inner style-check style-heading style-check mb-3">
                              {tab.points
                                .slice(Math.ceil(tab.points.length / 2))
                                .map((point, index) => (
                                  <li key={index}>
                                    <TiTick /> {point}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OurFocus;
